import React, {useEffect, useRef, useState} from "react";
import {connect, useSelector} from "react-redux";
import {
  registerUser,
  verifyOTP,
  registerUserModalClose,
  registerUserInterim,
  verifyUserInterim,
} from "./redux/login.action";
import {
  setIsLogin,
  setLoginVisibility,
} from "../../utils/commonredux/commonRedux.action";
import {getUserProfile} from "../Profile/redux/profile.action";
import LoginViaMobile from "./childComponents/LoginViaMobile";
import VerifyOtp from "./childComponents/VerifyOtp";

import {ScrollView, View, Text} from "react-native";
import {
  hideLoader,
  showLoader,
} from "../../commonComponents/Loader/loader.actions";

import {countryRegion, isMobile} from "../../utils/commonMethods";

import {useSafeAreaInsets} from "react-native-safe-area-context";
import Colors from "../../assets/Color/Colors";
import {globalFontStyle} from "../../assets";

const defaultCountry = {
  name: {
    en: "India",
  },
  dial_code: "+91",
  code: "IN",
  flag: "🇮🇳",
};

const MobileOTPVerification = ({
  registerUser,
  isSendOtpSuccess,
  verifyOTP,
  verifyOtpSuccess,
  profileData,
  registerUserModalClose,
  registerUserInterim,
  verifyUserInterim,
  showLoader,
  onBottomSheetClose,
  isProfile,
  showMobileOnly
}) => {
  const insets = useSafeAreaInsets();
  const [mobileNo, setMobileNo] = React.useState("");
  const [mode, setMode] = React.useState("login");
  const [error, setError] = useState("");
  const [country, setCountry] = useState(defaultCountry);
  const selectedSource = useRef("sms");

  const globalConfigData = useSelector(
    state => state.utilReducer.globalConfigData,
  );

  useEffect(() => {
    if (verifyOtpSuccess?.verified) {
      onBottomSheetClose();
    }
  }, [verifyOtpSuccess]);

  useEffect(() => {
    return () => {
      verifyUserInterim();
      registerUserInterim(false);
      registerUserModalClose();
    };
  }, []);

  useEffect(() => {
    if (isSendOtpSuccess?.success) {
      setMode("otp");
      setError("");
    } else if (isSendOtpSuccess?.error) {
      setError(isSendOtpSuccess.error);
    }
  }, [isSendOtpSuccess]);

  const onLoginSubmit = (inputData, isResendCode = false, source) => {
    if (source) {
      selectedSource.current = source;
    }

    showLoader();
    
    if (isResendCode) {
      registerUser(mobileNo, selectedSource.current, country?.dial_code);
    } else if (mode === "login") {
      setMobileNo(inputData);
      registerUser(inputData, selectedSource.current, country?.dial_code);
    } else if (mode === "otp") {
      let requestOtpData = {
        mobile: mobileNo,
        otp: inputData,
        country_code: country?.dial_code,
        signup_country: country?.code,
      };

      verifyOTP(requestOtpData);
    }
  };

  return (
    <ScrollView
      style={{
        paddingTop: insets.top,
        paddingBottom: insets.bottom,
        paddingLeft: insets.left,
        paddingRight: insets.right,
        marginTop: 10,
      }}
      keyboardShouldPersistTaps={"handled"}
      contentContainerStyle={{
        flexGrow: 1,
        backgroundColor: Colors.bgWhite,
      }}>
      <View style={{paddingHorizontal: 16}}>
        <Text
          style={{
            ...globalFontStyle.appFontHeading,
            color: Colors?.black,
            paddingBottom: 5,
            textAlign: 'center'
          }}>
          {mode === "otp" ? "OTP Verification" : "Enter your Phone Number"}
        </Text>

        <Text
          style={{
            ...globalFontStyle.appFontSubText,
            color: Colors?.lightgrey,
            paddingBottom: 25,
            textAlign: 'center'
          }}>
          {mode === "otp"
            ? "OTP has been sent to your number. Please enter the same to confirm."
            : "Please enter your phone number to verify"}
        </Text>
      </View>

      <View style={{flex: 1, paddingHorizontal: 16}}>
        {mode === "login" ? (
          <LoginViaMobile
            onLoginSubmit={onLoginSubmit}
            setCountry={setCountry}
            country={country}
            isIndia={true}
            showMobileOnly={true}
          />
        ) : mode === "otp" ? (
          <VerifyOtp
            onOTPSubmit={onLoginSubmit}
            registerUserInterim={registerUserInterim}
            isInternalVerify={true}
            mobileNo={mobileNo}
          />
        ) : null}
      </View>

      {error && (
        <Text style={{
          ...globalFontStyle.appFontSmallText,
          color: Colors.red,
          textAlign: 'center',
          marginTop: 16,
          paddingHorizontal: 16
        }}>
          {error}
        </Text>
      )}
    </ScrollView>
  );
};

const mapStateToProps = ({login, profile}) => ({
  isSendOtpSuccess: login.interimRegisterSuccess,
  verifyOtpSuccess: login.verifyOtp_success,
  profileData: profile.profileData,
});

const mapDispatchToProps = {
  registerUser,
  verifyOTP,
  setLoginVisibility,
  registerUserModalClose,
  registerUserInterim,
  verifyUserInterim,
  getUserProfile,
  setIsLogin,
  showLoader,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MobileOTPVerification);
